import { METHOD } from '../method'

export const API_PROMO_BANNER = {
    DETAIL: {
        api: '/v1/dashboard-admin/main-page/home-page/promo-banner',
        method: METHOD.GET,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/main-page/home-page/promo-banner',
        method: METHOD.PUT,
    },
    URL_PROMO_BANNER: {
        api: '/v1/dashboard-admin/main-page/home-page/promo-banner/storage-url/attachment',
        method: METHOD.POST,
    },
}
